"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickupPointsDeliveryMethod = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
const { Home, ...pickupPointsDeliveryMethod } = _globalApiClientReact.GetShoppingSessionDeliveryChannelsMethod;
const PickupPointsDeliveryMethod = exports.PickupPointsDeliveryMethod = pickupPointsDeliveryMethod; // eslint-disable-next-line @typescript-eslint/no-redeclare -- more accurate type from API for pickup points usage
